import axios from 'axios';
import _ from 'lodash';
import { store } from 'react-notifications-component';

// constants
import { showError, showNoInternet } from '../components/Common/alertmessage';
import LocalStrings from '../assets/languages';
import LanguageExtraJson from '../assets/languages/lang_en_extra.json';
import {
  INSTANCE_URL,
  FILES_URL,
  PORTAL_LOCALSTORAGE_ACCESS_KEY,
  TABLE_URI_ADDON,
  SCRIPT_URI_ADDON,
  LOCAL_TIMEZONE,
  LOCAL_TIMEZONE_LOCALE,
  INITIAL_APP_LANGUAGE,
  STOP_API_CALLS
} from '../constants/constant';
import {
  loadFromLocalDB,
  removeFromLocalStorage,
  setInLocalDB
} from '../reducers/localStorage';
import {
  getRegistrationLoginOpen,
  getUploadBaseURL,
  setScheduleInLocalStorage,
  isJSONParsable
} from '../util/util-common';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile,
  detection
} from '../components/Common/network-call';
import { getHeaders } from '../util/util-network';
import {
  ALLOWED_FORM_LAYOUTS,
  ALLOWED_FORM_PROFILE_IMAGE
} from '../constants/section-constants/editprofile-constants';
import {
  ALLOWED_APP_THEMES,
  ALLOWED_FLASH_POPUPS,
  ALLOWED_PIN_ACTION_TYPES,
  ALLOWED_POST_ANALYTICS_TYPES,
  ALLOWED_REPORTED_CONTENT_STRUCTURE,
  ALLOWED_REPORTED_CONTENT_TYPES,
  SITE_ACCESS_TYPES
} from '../constants/section-constants/type-constants';
import {
  SCRIPTS,
  TABLES,
  FIELDS,
  FETCH_ORDERS
} from '../constants/section-constants/eventify-constant';

// actions
import { updateSpeakersFiles } from '../components/myprofile/actions';
import { fetchExhibitorAnalytics } from '../components/exhibitors/actions';
import { globalSearchLatest } from '../components/global-search/actions';
import { ALLOWED_FEATURE_KEYS } from '../constants/section-constants/common-constants';

export const STOP_API_CALL_ACTION = 'STOP_API_CALL_ACTION';
export const INTERNET_CONNECTION_LOST = 'INTERNET_CONNECTION_LOST';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const LOGIN_MODAL = 'LOGIN_MODAL';
export const ACTION_LOGIN = 'ACTION_LOGIN';
export const ACTION_LOGOUT = 'ACTION_LOGOUT';
export const RESET = 'RESET';
export const SESSION_TOKEN = 'SESSION_TOKEN';
export const USER_INFO = 'USER_INFO';
export const USER_DETAILS = 'USER_DETAILS';
export const USER_DETAILS_ADDON = 'USER_DETAILS_ADDON';
export const USER_ACCESS = 'USER_ACCESS';

export const EVENT_DETAILS = 'EVENT_DETAILS';
export const EVENT_DETAILS_SESSION = 'EVENT_DETAILS_SESSION';
export const EVENT_SETTINGS = 'EVENT_SETTINGS';
export const EVENT_FORMS_DETAILS = 'EVENT_FORMS_DETAILS';
export const EVENT_TAB_LIST = 'EVENT_TAB_LIST';
export const EVENT_ALL_TICKETS = 'EVENT_ALL_TICKETS';
export const EVENT_LANGUAGES = 'EVENT_LANGUAGES';
export const EVENT_LOCATION_MAPS = 'EVENT_LOCATION_MAPS';

export const DEVICE_SIZE = 'DEVICE_SIZE';
export const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';
export const USER_DETAILS_QR = 'USER_DETAILS_QR';
export const APPUSER_CATEGORIES_LIST = 'APPUSER_CATEGORIES_LIST';
export const INTEREST_LIST = 'INTEREST_LIST';
export const EVENT_WEBVIEW_DETAILS = 'EVENT_WEBVIEW_DETAILS';
export const EVENT_ADVT_DETAILS = 'EVENT_ADVT_DETAILS';
export const REDIRECTING_CALLED_FROM = 'REDIRECTING_CALLED_FROM';
export const APPLY_COMMON_LOADER = 'APPLY_COMMON_LOADER';
export const ACTIVATE_NAVBAR_LINE_LOADER = 'ACTIVATE_NAVBAR_LINE_LOADER';
export const INVOKE_NETWORK_MODAL = 'INVOKE_NETWORK_MODAL';
export const TIMEZONE_DETAILS = 'TIMEZONE_DETAILS';
export const TICKETS_FOR_EVENT = 'TICKETS_FOR_EVENT';
export const MEETING_POPUP_DETAILS = 'MEETING_POPUP_DETAILS';
export const FETCH_UNREAD_CHAT = 'FETCH_UNREAD_CHAT';
export const UNAUTHORIZED_API_CALLED = 'UNAUTHORIZED_API_CALLED';
export const SITE_CONTROL = 'SITE_CONTROL';
export const PROFILE_TOGGLE = 'PROFILE_TOGGLE';
export const LAST_MODIFIED_REDUXFORM_FIELD = 'LAST_MODIFIED_REDUXFORM_FIELD';
export const USER_ACCESS_BY_ROLE = 'USER_ACCESS_BY_ROLE';
export const COMMON_ACCESS_DENIED_RENDER = 'COMMON_ACCESS_DENIED_RENDER';
export const TOKEN_EXPIRY_MODAL_STATUS = 'TOKEN_EXPIRY_MODAL_STATUS';
export const APPUSER_REPORTED_CONTENT = 'APPUSER_REPORTED_CONTENT';
export const COMMON_FILTER_SELECTED_LIST = 'COMMON_FILTER_SELECTED_LIST';
export const ON_FIRST_VISIT = 'ON_FIRST_VISIT';
export const INITIALIZE_APP = 'INITIALIZE_APP';
export const CHANGE_APP_LANGUAGE = 'CHANGE_APP_LANGUAGE';
export const CHANGE_APP_THEME = 'CHANGE_APP_THEME';
export const APP_FEATURE_LIST = 'APP_FEATURE_LIST';
export const APP_REG_LOGIN_OPEN = 'APP_REG_LOGIN_OPEN';
export const RESTRICT_USER_IN_EDIT = 'RESTRICT_USER_IN_EDIT';

const languageFields =
  'eventlanguages_by_eventid.fields=id,languagekey,languagetext,languagejson,isenabled';
const eventSettingsFields = `eventsettings_by_eventid.fields=${FIELDS.eventSettings.mediumInfo}`;
const eventTableRelated = `eventsettings_by_eventid,eventlanguages_by_eventid,locationmaps_by_eventid&${eventSettingsFields}&${languageFields}`;

export const checkEvent = (session, seocode, callback) => {
  // seocode = 'hopeevent';

  const filter = encodeURI(`(seocode=${seocode})`);
  const url = `${INSTANCE_URL}${TABLE_URI_ADDON}/${TABLES.event}?fields=${FIELDS.event.mediumInfo}&related=${eventTableRelated}&filter=${filter}`;

  let session_WO_token = _.cloneDeep(session);
  delete session_WO_token.sessionToken;

  return dispatch => {
    dispatch({
      type: INITIALIZE_APP,
      payload: {}
    });

    if (
      !_.isEmpty(session?.seocode) &&
      !_.isEqual(session?.seocode?.toLowerCase(), seocode.toLowerCase())
    ) {
      dispatch(
        mainLogout(session, {
          isTokenExp: false
        })
      );
    }

    getRequest(
      url,
      session_WO_token,
      dispatch,
      data => {
        if (!_.isEmpty(data.resource) && data?.resource?.[0]?.eventid) {
          const eventDetails = _.cloneDeep(data.resource[0]);

          // ----- event and event-details set
          const eventDetailsPayload = _.omit(eventDetails, [
            'eventsettings_by_eventid',
            'eventlanguages_by_eventid',
            'locationmaps_by_eventid'
          ]);
          dispatch({
            type: EVENT_DETAILS,
            payload: eventDetailsPayload
          });
          dispatch({
            type: EVENT_DETAILS_SESSION,
            payload: eventDetailsPayload
          });

          // --- Processing event settings
          const eventSettings = _.cloneDeep(
            eventDetails?.eventsettings_by_eventid?.[0]
          );
          _.map(eventSettings, (setVal, setCol) => {
            if (_.includes(FIELDS.eventSettings.allSettings, setCol)) {
              eventSettings[setCol] = _.attempt(JSON.parse, setVal) || setVal;
            }
          });
          dispatch({
            type: EVENT_SETTINGS,
            payload: eventSettings
          });

          // --- Processing event languages
          const eventLanguages =
            _.filter(
              eventDetails?.eventlanguages_by_eventid,
              ea => ea?.isenabled
            ) ?? [];
          dispatch({ type: EVENT_LANGUAGES, payload: eventLanguages });

          // --- Processing event location maps
          const eventLocationMaps = _.orderBy(
            eventDetails?.locationmaps_by_eventid,
            FETCH_ORDERS.locationmaps.internal.fields,
            FETCH_ORDERS.locationmaps.internal.order
          );
          dispatch({ type: EVENT_LOCATION_MAPS, payload: eventLocationMaps });

          // ----- Site access
          dispatch(
            checkSiteAccess({ ...session, eventid: eventDetails.eventid })
          );

          // ----- event theme color set to root
          dispatch(
            updateAppTheme(
              eventDetails,
              eventSettings,
              session?.theme,
              session?.userChoseTheme,
              true
            )
          );

          // ----- Creating the timezone details
          handleTimeZone(eventDetails, eventSettings, dispatch);

          // ----- Custom code injection (173)
          handleCustomCodeInjection(eventSettings);

          // ----- Initiating app language
          handleAppLanguage(eventLanguages, session, dispatch);

          // ----- Determining reg-login allow
          const regLoginOpen = getRegistrationLoginOpen(eventSettings);
          dispatch({
            type: APP_REG_LOGIN_OPEN,
            payload: regLoginOpen
          });

          // ----- callback sent
          callback({
            success: 1,
            resource: data.resource
          });
        } else {
          callback({
            success: 0
          });
        }
      },
      error => {}
    );
  };
};

// - If conversion required in app
const handleTimeZone = (eventDetails, eventSettings, dispatch) => {
  let tzObj = {};
  tzObj.showconvertedtimezone = eventDetails?.showconvertedtimezone;

  const scheduleLocalstorage = loadFromLocalDB(
    PORTAL_LOCALSTORAGE_ACCESS_KEY.schedule
  );
  if (
    _.isNull(scheduleLocalstorage) ||
    (!_.isNull(scheduleLocalstorage) && !scheduleLocalstorage?.userUpdated)
  )
    setScheduleInLocalStorage(eventDetails, eventSettings);

  // - date and str conversion
  let date = new Date();
  let dateAsString = date.toString();
  tzObj.today = date;
  tzObj.dateAsString = dateAsString;
  // - tz selection
  const tz = LOCAL_TIMEZONE; // Client time-zone
  let timezone = eventDetails?.eventtimezone;
  if (!timezone) {
    eventDetails = {
      ...data.resource[0],
      eventtimezone: tz
    };
    timezone = tz;
  }
  tzObj.eventTimezone = timezone;
  tzObj.clientTimezone = tz;
  tzObj.locale = LOCAL_TIMEZONE_LOCALE;

  // - timezone set
  dispatch({ type: TIMEZONE_DETAILS, payload: tzObj });
};

// - Portal custom code injection
const handleCustomCodeInjection = eventSettings => {
  const customCSS = eventSettings?.webportal_css;
  const customScript = eventSettings?.webportal_script;

  // Inject CSS if available
  if (customCSS) {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = customCSS.replace(/<\/?style>/g, ''); // Remove <style> tags
    document.head.appendChild(styleElement);
  }

  // Inject Script if available
  if (customScript) {
    // Create a container for the scripts
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = customScript;

    // Append the scripts to the head
    const scripts = tempDiv.getElementsByTagName('script');
    _.forEach(scripts, script => {
      const newScript = document.createElement('script');
      if (script.src) {
        // External script
        newScript.src = script.src;
        newScript.async = script.async;
      } else {
        // Inline script
        newScript.textContent = script.textContent;
      }
      document.head.appendChild(newScript);
    });

    return;
  }
};

// - App language initiator
const handleAppLanguage = (eventLanguages, session, dispatch) => {
  // --- Language extracting, checking in DB, setting locally
  // With this the filtered language file from DB will be set locally. If any key is not found, then it by default reverts back to default language(en)
  let param_lang = _.split(
    navigator.language || navigator.userLanguage,
    '-'
  ).shift();
  if (
    !_.isEmpty(window.location.search) &&
    _.isEqual(window.location.pathname, '/myprofile')
  ) {
    const queryParams = new URLSearchParams(window.location.search);
    param_lang = queryParams.get('language');
  }
  if (!_.isEqual(param_lang, session?.language)) param_lang = session?.language;

  // - filtering if param_language is present for the event in DB
  let paramLangFile = _.find(eventLanguages, lang =>
    _.isEqual(lang.languagekey, param_lang)
  );
  if (_.isEmpty(paramLangFile)) {
    paramLangFile = eventLanguages[0];
    param_lang = eventLanguages[0]?.languagekey;
  }

  if (!_.isEmpty(param_lang) && !_.isEqual(param_lang, INITIAL_APP_LANGUAGE))
    document.body.style.fontFamily = 'var(--inter-font)';

  if (
    !_.isEmpty(paramLangFile) &&
    isJSONParsable(paramLangFile?.languagejson)
  ) {
    const local_lang = JSON.parse(paramLangFile?.languagejson);
    const languageKey = paramLangFile?.languagekey;

    LocalStrings.setContent({
      [languageKey]: {
        extra: {
          ..._.cloneDeep(LanguageExtraJson)
        },
        dynamic: {
          ..._.cloneDeep(LocalStrings?.dynamic),
          ...local_lang
        }
      }
    });
    LocalStrings.setLanguage(languageKey);

    // Document language set | <html lang="">
    document.documentElement.lang = languageKey;

    // Preventing browser to auto translate | <meta name="google" content="notranslate">
    const existingMeta = document.querySelector('meta[name="google"]');
    if (languageKey !== INITIAL_APP_LANGUAGE) {
      if (!existingMeta) {
        const meta = document.createElement('meta');
        meta.name = 'google';
        meta.content = 'notranslate';
        document.head.appendChild(meta);
      } else {
        existingMeta.setAttribute('content', 'notranslate');
      }
    } else {
      // Removing the tag as needed for en
      if (existingMeta) {
        existingMeta.remove();
      }
    }

    dispatch(updateAppLanguage(languageKey));
  }
};

/**
 * Manages siteControl reducer based on allowaccess
 */
const checkSiteAccess = (session, callback = null) => {
  if (_.isNull(session?.eventid)) return dispatch => {};

  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.allowAccess.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.getCommon.allowAccess.payload);
  postBody.eventid = session?.eventid;

  /**
   * NOTE:
   * exists => Client validation
   * success => Login validation
   * access => Event validation
   */

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        const accessType = !res?.exists
          ? SITE_ACCESS_TYPES.expired // No access to event
          : res?.success
          ? SITE_ACCESS_TYPES.allow // Normal access
          : res?.access
          ? SITE_ACCESS_TYPES.restrict // edit profile only
          : SITE_ACCESS_TYPES.noAccess; // Session not allowed

        dispatch(setSiteControl(accessType));
        callback && callback({ success: 1, accessType, error: null });
      },
      error => {
        dispatch(setSiteControl(SITE_ACCESS_TYPES.restrict));
        callback && callback({ success: 0, accessType, error });
      }
    );
  };
};

export const checkToken = (session, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.user.session.endpoint}?appuserid=${session?.userid}&eventid=${session?.eventid}&callfrom=appwebprofile`;
  let response = axios.get(url, getHeaders(session));

  return dispatch => {
    response
      .then(({ data }) => {
        if (data.is_valid_user) {
          callback({ success: 1 });
        } else {
          dispatch(
            recallCheckEvent(session, res => {
              callback({ success: 1 });
            })
          );
        }
      })
      .catch(error => {
        dispatch(
          recallCheckEvent(session, res => {
            callback({ success: 1, message: error });
          })
        );
      });
  };
};

export const setDeviceSize = obj => {
  return dispatch => {
    dispatch({ type: DEVICE_SIZE, payload: obj });
  };
};

export const showSidebar = value => {
  return dispatch => {
    dispatch({ type: SHOW_SIDEBAR, payload: value });
  };
};

export const setCommonFilterList = value => {
  return dispatch => {
    dispatch({ type: COMMON_FILTER_SELECTED_LIST, payload: value });
  };
};

export const loginModal = obj => {
  return dispatch => {
    dispatch({ type: LOGIN_MODAL, payload: obj });
  };
};

export const loginWithEmail = (
  session,
  credential = { email: '', passcode: '' },
  callback
) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.magicEmail.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.magicEmail.payload);
  postBody.eventid = session.eventid;
  postBody.email = credential?.email;
  if (!_.isEmpty(credential?.passcode)) postBody.apcode = credential?.passcode;

  let session_WO_token = _.cloneDeep(session);
  delete session_WO_token.sessionToken;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session_WO_token,
      dispatch,
      loginRes => {
        if (
          !_.isEmpty(loginRes) &&
          loginRes?.isverified &&
          !_.isEmpty(loginRes?.user) &&
          !_.isEmpty(loginRes?.token?.session_token)
        ) {
          handleLoginComplete(session, dispatch, loginRes, callback);
        } else {
          callback({ success: 1, data: loginRes, error: null });
        }
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const loginWithPassCode = (
  session,
  credential = { passcode: '', emailToken: '' },
  callback
) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.verifyToken.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.verifyToken.payload);
  postBody.eventid = session.eventid;
  postBody.passcode = credential?.passcode;
  postBody.token = credential?.emailToken;

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      loginRes => {
        if (
          !_.isEmpty(loginRes) &&
          loginRes?.isverified &&
          !_.isEmpty(loginRes?.user) &&
          !_.isEmpty(loginRes?.token?.session_token)
        ) {
          handleLoginComplete(session, dispatch, loginRes, callback);
        } else {
          callback({ success: 0, data: null, error: null });
        }
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const loginWithSSO = (session, loginRes, callback = () => {}) => {
  return dispatch => {
    handleLoginComplete(session, dispatch, loginRes, callback);
  };
};

const handleLoginComplete = (session, dispatch, loginRes, callback) => {
  const token = loginRes?.token?.session_token;
  const user = loginRes?.user;
  const dfIdToken = {
    id: user?.dfid ?? 0,
    session_token: token
  };

  dispatch(
    validateUserRelatedToEvent(
      {
        ...session,
        sessionToken: token
      },
      {
        type: 'db',
        id: user?.appuserid
      },
      dfIdToken,
      user,
      validRes => {
        callback({
          success: 1,
          login: true, // Helps for eventsettings.autologin case, bypasses passcode step
          data: validRes,
          error: null
        });
      }
    )
  );
};

const validateUserRelatedToEvent = (
  session,
  userId = { type: 'df', id: 0 }, // type: df|db
  dfIdToken, // has fetched dfid and session token
  appuserData = null,
  callback
) => {
  // Check whether logged in user is admin or not
  const filter = encodeURI(
    `(eventid=${session.eventid})${
      userId.type === 'df'
        ? `AND(dfid=${userId.id})`
        : userId.type === 'db'
        ? `AND(appuserid=${userId.id})`
        : ''
    }`
  );
  const appuserFields =
    !_.isEmpty(appuserData) && appuserData?.firstname
      ? `fields=${FIELDS.appuser.minInfo},email&`
      : '';
  const appuserRelated =
    'tickets_by_ticketid,ticket_attendees_by_userid,speaker_by_speakeridfk,sponsor_by_sponsoridfk,exhibitors_by_exhibitoridfk';
  const url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?${appuserFields}related=${appuserRelated}&filter=(${filter})`;

  const flashPopupDDetails = loadFromLocalDB(
    PORTAL_LOCALSTORAGE_ACCESS_KEY.flashPopups
  );
  const requiredPrivacySelected =
    !_.isEmpty(flashPopupDDetails) &&
    _.isEqual(
      flashPopupDDetails?.[ALLOWED_FLASH_POPUPS.types.privacy],
      ALLOWED_FLASH_POPUPS.privacyTypes[2]
    );

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        const fetchedAppUserData = {
          ...(!_.isEmpty(data.resource[0]) ? data.resource[0] : {}),
          ...(!_.isEmpty(appuserData) ? appuserData : {})
        };

        let userInfoPayload = requiredPrivacySelected
          ? _.omit(fetchedAppUserData, ['email', 'firstname', 'lastname'])
          : fetchedAppUserData;

        if (data.resource.length > 0) {
          dispatch({ type: SESSION_TOKEN, payload: dfIdToken });
          dispatch({
            type: USER_INFO,
            payload: userInfoPayload
          });
          dispatch(
            fetchEventForms(
              {
                ...session,
                eventid: fetchedAppUserData?.eventid
              },
              res => {
                const processedUserDetails = handleUserDetails(
                  fetchedAppUserData,
                  res?.data?.layouts
                );
                dispatch({
                  type: USER_DETAILS,
                  payload: processedUserDetails
                });
                dispatch({
                  type: USER_DETAILS_ADDON,
                  payload: processedUserDetails
                });
                dispatch({ type: ACTION_LOGIN, payload: true });

                callback({
                  success: 1,
                  data: processedUserDetails
                });
              }
            )
          );
        } else {
          callback({ success: 2, message: 'Invalid User!' });
        }
      },
      error => {
        callback({ success: 0, data: null, message: error });
      }
    );
  };
};

// ----- action for 403 token error | Access forbidden
export const recallCheckEvent = (session, callback = null) => {
  // ----- storing a local version of session before clearing localStorage
  const localSession = {
    apiKey: session.apiKey,
    eventid: session.eventid,
    eventname: session.eventname,
    eventtimezone: session.eventtimezone,
    seocode: session.seocode
  };

  // ----- clearing localStorage
  try {
    localStorage.setItem(
      PORTAL_LOCALSTORAGE_ACCESS_KEY.state,
      JSON.stringify({ isLoggedIn: false, session: localSession })
    );
  } catch (err) {}

  return dispatch => {
    // Maintaining a flag here
    dispatch(setUnauthorisedApiCall(true));
    dispatch(
      checkEvent(localSession, session.seocode, res => {
        callback && callback(res?.success);
      })
    );
  };
};

export const setUnauthorisedApiCall = (boolVal = false) => {
  return dispatch =>
    dispatch({ type: UNAUTHORIZED_API_CALLED, payload: boolVal });
};

// ----- Action for 401 token error | Token expired
export const setTokenExpiredModal = value => {
  return dispatch => {
    dispatch({ type: TOKEN_EXPIRY_MODAL_STATUS, payload: value });
    if (!value) dispatch(loginModal({ showModal: true }));
  };
};

// ----- Axios call 500 handle for no internet (687)
export const detectedNoInternetInAxios = () => {
  // const id = showNoInternet();
  // setInLocalDB({
  //   key: PORTAL_LOCALSTORAGE_ACCESS_KEY.netConnection,
  //   value: id
  // });

  return dispatch => {
    dispatch({
      type: STOP_API_CALL_ACTION,
      payload: true
    });
    dispatch({
      type: INTERNET_CONNECTION_LOST,
      payload: true
    });
  };
};

export const internetConnectionRestored = () => {
  const id = loadFromLocalDB(PORTAL_LOCALSTORAGE_ACCESS_KEY.netConnection);
  store.removeNotification(id);
  removeFromLocalStorage(PORTAL_LOCALSTORAGE_ACCESS_KEY.netConnection);

  return dispatch => {
    dispatch({
      type: STOP_API_CALL_ACTION,
      payload: STOP_API_CALLS
    });
    dispatch({
      type: INTERNET_CONNECTION_LOST,
      payload: false
    });
  };
};

export const detectInternetConnection = session => {
  return dispatch => {
    detection(
      `${INSTANCE_URL}${TABLE_URI_ADDON}/${TABLES.event}?fields=eventid&filter=(seocode=${session?.seocode})`,
      session,
      dispatch,
      res => {
        if (res?.success) {
          dispatch(internetConnectionRestored());
        }
      }
    );
  };
};

export const validateEmailForAppUser = (session, values, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(email=${values.email})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        if (data.resource.length > 0) {
          callback({ success: 2 });
        } else {
          callback({ success: 1 });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchUserQR = (session, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.userQR.getQR.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.userQR.getQR.payload);
  body.userid = session.userid;
  body.eventid = session.eventid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        dispatch({ type: USER_DETAILS_QR, payload: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchUserAccess = (session, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventifyScriptSupport.appuserAccess.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.eventifyScriptSupport.appuserAccess.payload);
  body.eventid = session.eventid;
  body.appuserid = session.userid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        dispatch({ type: USER_ACCESS, payload: response });
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const mainLogout = (
  session,
  { isTokenExp = false },
  callback = null
) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.user.session.endpoint}`;
  let response = axios.delete(url, getHeaders(session));
  document.cookie = `smartbanner-closed=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  return dispatch => {
    response
      .then(({ data }) => {
        dispatch({ type: ACTION_LOGOUT, payload: false });
        dispatch(globalSearchLatest([]));
        dispatch(updateUserAccessByRole());
        isTokenExp && dispatch(setTokenExpiredModal(false));
        callback && callback({ success: 1 });
      })
      .catch(error => {
        // nothing to do
        dispatch({ type: ACTION_LOGOUT, payload: false });
        isTokenExp && dispatch(setTokenExpiredModal(false));
        callback && callback({ success: 0 });
      });
  };
};

export const resetAll = () => {
  return dispatch => {
    dispatch({ type: 'RESET' });
  };
};
// .formlayout.profileimage
// Common Functions
export const fetchEventForms = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let eventSettingsRelated = `event_forms_by_eventformid,event_forms_by_exhibitorformid,event_forms_by_sponsorformid,event_forms_by_sesseionratingformid`;
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.eventSettings}?fields=${FIELDS.eventSettings.minInfo}&related=${eventSettingsRelated}&event_forms_by_eventformid.fields=formjson,formlayout,profileimage&event_forms_by_exhibitorformid.fields=formlayout,profileimage&event_forms_by_sponsorformid.fields=formlayout,profileimage&event_forms_by_sesseionratingformid.fields=formjson&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        const eventForm = _.cloneDeep(
          data?.resource[0]?.event_forms_by_eventformid
        );

        const sessionForm = _.cloneDeep(
          data?.resource[0]?.event_forms_by_sesseionratingformid
        );

        _.map(eventForm, (setVal, setCol) => {
          if (setCol === 'formjson' && typeof setVal === 'string') {
            eventForm[setCol] = _.attempt(JSON.parse, setVal) || setVal;
          }
        });

        _.map(sessionForm, (setVal, setCol) => {
          if (setCol === 'formjson' && typeof setVal === 'string') {
            sessionForm[setCol] = _.attempt(JSON.parse, setVal) || setVal;
          }
        });

        let payloadObj = {
          resource: data?.resource[0],
          eventForm,
          exhibitorForm: data?.resource[0]?.event_forms_by_exhibitorformid,
          sponsorForm: data?.resource[0]?.event_forms_by_sponsorformid,
          sessionForm,
          layouts: {
            attendee:
              data.resource?.[0]?.event_forms_by_eventformid?.formlayout ??
              ALLOWED_FORM_LAYOUTS.single,
            exhibitor:
              data.resource?.[0]?.event_forms_by_exhibitorformid?.formlayout ??
              ALLOWED_FORM_LAYOUTS.single,
            sponsor:
              data.resource?.[0]?.event_forms_by_sponsorformid?.formlayout ??
              ALLOWED_FORM_LAYOUTS.single
          },
          profileImage: {
            attendee:
              data.resource?.[0]?.event_forms_by_eventformid?.profileimage ??
              ALLOWED_FORM_PROFILE_IMAGE.optional,
            exhibitor:
              data.resource?.[0]?.event_forms_by_exhibitorformid
                ?.profileimage ?? ALLOWED_FORM_PROFILE_IMAGE.optional,
            sponsor:
              data.resource?.[0]?.event_forms_by_sponsorformid?.profileimage ??
              ALLOWED_FORM_PROFILE_IMAGE.optional
          }
        };

        dispatch({
          type: EVENT_FORMS_DETAILS,
          payload: payloadObj
        });
        callback({ success: 1, data: payloadObj });
      },
      error => {}
    );
  };
};

export const fetchMyProfile = (
  session,
  profileData = null,
  eventFormsData = null,
  callback = null
) => {
  if (_.isEmpty(session.sessionToken)) return dispatch => {};

  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?related=tickets_by_ticketid,ticket_attendees_by_userid,speaker_by_speakeridfk,sponsor_by_sponsoridfk,exhibitors_by_exhibitoridfk&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        if (data.resource.length == 0) {
          // ----- storing a local version of session before clearing localStorage
          let localSession = {
            apiKey: session.apiKey,
            eventid: session.eventid,
            eventname: session.eventname,
            eventtimezone: session.eventtimezone,
            seocode: session.seocode
          };

          // ----- clearing localStorage
          try {
            localStorage.clear();
          } catch (err) {}

          // ----- recalling the 1st api ever called
          dispatch(
            recallCheckEvent(localSession, res => {
              if (callback) callback({ success: true });
            })
          );
        } else {
          // callback && callback({ success: true });

          if (!_.isEmpty(eventFormsData)) {
            const processedUserDetails = handleUserDetails(
              data.resource[0],
              eventFormsData?.layouts
            );
            dispatch(fullScreenLoaderHandler(false));
            dispatch({
              type: USER_DETAILS,
              payload: processedUserDetails
            });
            dispatch({
              type: USER_DETAILS_ADDON,
              payload: processedUserDetails
            });

            dispatch(
              handleProfileDetailsAfterSave(
                processedUserDetails,
                profileData,
                res => {
                  if (callback) callback({ success: true });
                }
              )
            );
          } else {
            dispatch(
              fetchEventForms(
                {
                  ...session,
                  eventid: data.resource[0].eventid
                },
                res => {
                  const processedUserDetails = handleUserDetails(
                    data.resource[0],
                    res?.data?.layouts
                  );
                  dispatch(fullScreenLoaderHandler(false));
                  dispatch({
                    type: USER_DETAILS,
                    payload: processedUserDetails
                  });
                  dispatch({
                    type: USER_DETAILS_ADDON,
                    payload: processedUserDetails
                  });

                  dispatch(
                    handleProfileDetailsAfterSave(
                      processedUserDetails,
                      profileData,
                      res => {
                        if (callback) callback({ success: true });
                      }
                    )
                  );
                }
              )
            );
          }

          dispatch(
            speakerAttachment(data.resource[0].speaker_by_speakeridfk, dispatch)
          );
        }
      },
      error => {}
    );
  };
};

export const fetchEventContentTabs = (session, callback = null) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.apptabs}?fields=${FIELDS.apptabs.maxInfo}&filter=${fetchFilter}&order=${FETCH_ORDERS.apptabs}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_TAB_LIST,
          payload: data.resource
        });
        callback && callback({ success: 1, data: data.resource });
      },
      error => {
        callback && callback({ success: 0 });
      }
    );
  };
};

export const fetchTickets = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.tickets}?related=event_forms_by_formid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_ALL_TICKETS,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const speakerAttachment = (speaker, dispatch) => {
  if (!_.isEmpty(speaker)) {
    let fileName1 = '';
    let fileName2 = '';
    let fileName3 = '';
    let fileName4 = '';
    let fileName5 = '';
    if (speaker.file1) {
      let f1 = speaker.file1.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName1 = f2 + '.' + ext;
    }
    if (speaker.file2) {
      let f1 = speaker.file2.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName2 = f2 + '.' + ext;
    }
    if (speaker.file3) {
      let f1 = speaker.file3.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName3 = f2 + '.' + ext;
    }
    if (speaker.file4) {
      let f1 = speaker.file4.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName4 = f2 + '.' + ext;
    }
    if (speaker.file5) {
      let f1 = speaker.file5.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName5 = f2 + '.' + ext;
    }
    let files = [
      {
        position: 'file1',
        file: speaker.file1 ? speaker.file1 : '',
        filename: fileName1
      },
      {
        position: 'file2',
        file: speaker.file2 ? speaker.file2 : '',
        filename: fileName2
      },
      {
        position: 'file3',
        file: speaker.file3 ? speaker.file3 : '',
        filename: fileName3
      },
      {
        position: 'file4',
        file: speaker.file4 ? speaker.file4 : '',
        filename: fileName4
      },
      {
        position: 'file5',
        file: speaker.file5 ? speaker.file5 : '',
        filename: fileName5
      }
    ];
    dispatch(updateSpeakersFiles(files));
  }
};

export const updateActiveTab = name => {
  return dispatch => {
    dispatch({ type: UPDATE_ACTIVE_TAB, payload: name });
  };
};

export const handleFirstVisit = values => {
  return dispatch => {
    dispatch({ type: ON_FIRST_VISIT, payload: values });
  };
};

export const fetchAndFilterByBookMark = (
  url,
  session,
  type,
  dispatch,
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=${type})`
  );
  let bookmarkUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?fields=bookmarkid,typeid&filter=(${filter})`;
  getRequest(
    url,
    session,
    dispatch,
    data => {
      getRequest(bookmarkUrl, session, dispatch, bookmarkData => {
        for (let arr in data.resource) {
          let match = [];
          if (type === 'exhibitor') {
            match = _.filter(bookmarkData.resource, obj => {
              return obj.typeid === data.resource[arr].exhibitorid;
            });
          } else if (type === 'sponsor') {
            match = _.filter(bookmarkData.resource, obj => {
              return obj.typeid === data.resource[arr].sponsorid;
            });
          }

          data.resource[arr] = {
            ...data.resource[arr],
            isBookMarked: false
          };
          if (match.length > 0) {
            data.resource[arr] = {
              ...data.resource[arr],
              isBookMarked: true
            };
          }
        }

        if (type === 'sponsor') {
          // listing sponsors membership priority wise
          let arr = _.sortBy(data.resource, spon => {
            return spon.membershiptype_by_categoryid?.priorityindex;
          });

          data.resource = arr;
        }

        callback(data);
      });
    },
    error => {
      callback({ message: error });
    }
  );
};

export const saveBookmark = (session, type, typeid, callback) => {
  const url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}`;
  const body = {
    resource: [
      {
        eventid: `${session.eventid}`,
        type,
        typeid: `${typeid}`,
        appuserid: `${session.userid}`
      }
    ]
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        if (type === 'exhibitor') {
          dispatch(
            fetchExhibitorAnalytics(session, { type, id: typeid }, res => {
              if (res.success && res.message == 'Success') {
                callback({
                  success: 1,
                  data: response.resource
                });
              }
            })
          );
        } else {
          callback({ success: 1, data: response.resource });
        }
      },
      error => {
        callback(error);
      }
    );
  };
};

export const deleteBookmark = (session, typeid, callback) => {
  const filter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid})AND(typeid=${typeid}))`
  );

  const url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?filter=${filter}`;
  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1, response });
      },
      error => {
        callback(error);
      }
    );
  };
};

export const fetchAppuserCategory = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appusergroups}?&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: APPUSER_CATEGORIES_LIST,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchInterests = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.interests}?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: INTEREST_LIST,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

/**
 * @param extra array [screen, type, associatedid, searchtext, hassearchresult]
 */
export const postAnalytics = (
  session,
  extra = [
    '', // screen
    '', // type
    null, // associatedid
    null, // searchtext
    0 // hassearchresult
  ],
  callback = () => {}
) => {
  if (
    _.isEmpty(session) ||
    _.isNil(session?.eventid) ||
    _.isEmpty(extra?.[0]) || // screen
    _.isEmpty(extra?.[1]) || // type
    !_.includes(ALLOWED_POST_ANALYTICS_TYPES.screens, extra?.[0]) || // known screen
    !_.includes(ALLOWED_POST_ANALYTICS_TYPES.types, extra?.[1]) // known type
  )
    return dispatch => {};

  // Post Analytics Data
  let anaData = _.cloneDeep(SCRIPTS.analytics.appAnalytics);
  anaData.eventid = session.eventid;

  const postUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appanalytics}`;
  const postBody = {
    resource: [
      {
        dfid: session?.udfid ? session?.udfid : 0,
        eventid: session?.eventid,
        group_number: session?.group_number,
        screen: extra[0],
        type: extra[1],
        associatedid: extra[2],
        searchtext: extra[3],
        hassearchresult: extra[4],
        data: JSON.stringify(anaData)
      }
    ]
  };

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const updateAppuser = (session, userData, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}/${session.userid}`;

  return dispatch => {
    patchRequest(
      url,
      userData,
      session,
      dispatch,
      patchRes => {
        callback({ success: true });
        dispatch(fetchMyProfile(session));
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchWebviewDetails = (
  session,
  extra = { apptabId: null },
  callback
) => {
  let filter = encodeURI(
    `((eventid=${session.eventid})AND(apptabid IN (${extra.apptabId.join(
      ','
    )})))`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.webview}?filter=${filter}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_WEBVIEW_DETAILS,
          payload: data.resource
        });
        callback({ success: 1, resource: data.resource });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const fetchAdvertisements = (
  session,
  extra = { groupIds: [] },
  callback = () => {}
) => {
  const fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(isenabled=1))`
  );
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.advertisement}?filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        // 'overviewinline','sidemenu','splash','home'
        const adList = _.filter(res.resource, ad => {
          const specificGroups = ad?.assigned_groups
            ? _.map(_.split(ad?.assigned_groups, ','), Number)
            : [];
          return (
            !_.isEqual(ad?.screen, 'splash') && // Filtering splash as N/A for portal
            (_.isEmpty(specificGroups) ||
              _.intersection(specificGroups, extra?.groupIds).length > 0) // common b/w usercategory and add-group
          );
        });

        dispatch({ type: EVENT_ADVT_DETAILS, payload: adList });
        callback && callback({ success: 1, resource: adList, error: null });
      },
      error => {
        callback && callback({ success: 0, resource: null, error });
      }
    );
  };
};

export const redirectingCalledFrom = calledFrom => {
  return dispatch => {
    dispatch({ type: REDIRECTING_CALLED_FROM, payload: calledFrom });
  };
};

export const fullScreenLoaderHandler = value => {
  return dispatch => {
    dispatch({ type: APPLY_COMMON_LOADER, payload: value });
  };
};

export const activateNavbarLineLoader = value => {
  return dispatch =>
    dispatch({ type: ACTIVATE_NAVBAR_LINE_LOADER, payload: value });
};

export const commonNetworkModal = value => {
  return dispatch => {
    dispatch({ type: INVOKE_NETWORK_MODAL, payload: value });
  };
};

export const fetchTicketsForEvent = (session, callback) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.tickets}?fields=${FIELDS.tickets.minInfo}&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({ type: TICKETS_FOR_EVENT, payload: res.resource });
        callback({ success: 1, data: res.resource });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchUnreadChat = (session, callback = null) => {
  let fetchUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.networkUsers.unreadCount.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.networkUsers.unreadCount.payload);
  postBody.appuserid = session.userid;
  postBody.eventid = session.eventid;

  return dispatch => {
    postRequest(
      fetchUrl,
      postBody,
      session,
      dispatch,
      response => {
        dispatch({
          type: FETCH_UNREAD_CHAT,
          payload: {
            data: response.users,
            totalUnread: response.totalUnread
          }
        });
      },
      error => {
        callback && callback({ success: 0, message: error });
      }
    );
  };
};

// ----- Manages how user access the site
// allow => can access site
// expired => 404, can not access site
// restrict => Show only minimum event details on overview, can not access site
// allow-admin => Allow admin on restrict mode
export const setSiteControl = value => {
  return dispatch => dispatch({ type: SITE_CONTROL, payload: value });
};

// ----- Manages the profile portal toggle
/* 
  values => Either 
  { 
    show: false <bool>, 
    type: '', <enum | 'profile', 'exhibitor', 'sponsor', 'speaker'>
    data: {}, <type wise section object, comes from src/action USER_DETAILS>
    active_tab: {}, <selected section object>,
    sections: [], <indexed sections for selected profile type>
  }
  OR user details
  type => null | string 'profile'; If type is 'profile' then 1st param will be user details
*/
export const setProfilePortalToggle = (values, type = null) => {
  let payloadValue = _.cloneDeep(values);

  if (
    _.includes(
      [
        'profile',
        ALLOWED_FEATURE_KEYS.exhibitor,
        ALLOWED_FEATURE_KEYS.speaker,
        ALLOWED_FEATURE_KEYS.sponsor
      ],
      type
    )
  ) {
    payloadValue = {
      show: true,
      type: type,
      data: {
        profile: values.personal_profile,
        exhibitor: values.exhibitor_profile,
        speaker: values.speaker_profile,
        sponsor: values.sponsor_profile
      },
      active_tab: {},
      sections: [],
      activeIndex: 0
    };

    switch (type) {
      case ALLOWED_FEATURE_KEYS.exhibitor:
        _.map(values?.exhibitor_profile, (section, sectionIndex) =>
          payloadValue.sections.push(sectionIndex)
        );
        payloadValue.active_tab = values?.exhibitor_profile?.profile_details;
        break;

      case ALLOWED_FEATURE_KEYS.speaker:
        _.map(values?.speaker_profile, (section, sectionIndex) =>
          payloadValue.sections.push(sectionIndex)
        );
        payloadValue.active_tab = values?.speaker_profile?.profile_details;
        break;

      case ALLOWED_FEATURE_KEYS.sponsor:
        _.map(values?.sponsor_profile, (section, sectionIndex) =>
          payloadValue.sections.push(sectionIndex)
        );
        payloadValue.active_tab = values?.sponsor_profile?.profile_details;
        break;

      case 'profile':
      default:
        _.map(values?.personal_profile, (section, sectionIndex) =>
          payloadValue.sections.push(sectionIndex)
        );
        payloadValue.active_tab = values?.personal_profile?.profile_details;
        break;
    }
  }

  return dispatch => dispatch({ type: PROFILE_TOGGLE, payload: payloadValue });
};

// ----- Will update the profile toggle reducer data after existing data is updated
/**
 * userDetails => updated profile reducer data (USER_DETAILS)
 * profileDetails => profileToggle reducer data (PROFILE_TOGGLE)
 */
export const handleProfileDetailsAfterSave = (
  userDetails,
  profileDetails,
  callback = null
) => {
  if (!_.isEmpty(userDetails) && profileDetails?.show) {
    let payloadObj = {
      ...profileDetails,
      data: {
        profile: userDetails?.personal_profile,
        exhibitor: userDetails?.exhibitor_profile,
        sponsor: userDetails?.sponsor_profile,
        speaker: userDetails?.speaker_profile
      }
    };

    let selectedProfile =
      profileDetails.type === 'exhibitor'
        ? 'exhibitor_profile'
        : profileDetails.type === 'sponsor'
        ? 'sponsor_profile'
        : profileDetails.type === 'speaker'
        ? 'speaker_profile'
        : 'personal_profile';

    if (_.isEmpty(profileDetails?.active_tab)) {
      payloadObj.active_tab = userDetails[selectedProfile].profile_details;

      payloadObj.sections = [];
      _.map(userDetails[selectedProfile], (section, sectionIndex) =>
        payloadObj.sections.push(sectionIndex)
      );
      payloadObj.activeIndex = 0;
    } else if (!_.isEmpty(profileDetails?.active_tab)) {
      _.map(userDetails[selectedProfile], (section, sectionKey) => {
        if (section.id == profileDetails?.active_tab?.id) {
          payloadObj.active_tab = section;
        }
      });
    }

    if (callback) callback({ success: 1 }); // Only call back is required, not payload
    return dispatch => {
      dispatch(setProfilePortalToggle(payloadObj));
    };
  } else {
    if (callback) callback({ success: 1 });
    return dispatch => {};
  }
};

// add comments for postComments
export const commonAddComment = (
  session,
  { data = null, endPoint = null, updateId = null },
  callback
) => {
  if (_.isEmpty(data) || _.isEmpty(endPoint)) return dispatch => {};

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${endPoint}${
    !_.isNull(updateId) ? `/${updateId}` : ''
  }`;
  let body = !_.isNull(updateId) ? data : { resource: [{ ...data }] };

  return dispatch => {
    !_.isNull(updateId)
      ? patchRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1, post: false });
          },
          error => {
            callback({ success: 0, post: false });
          }
        )
      : postRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1, post: true });
          },
          error => {
            callback({ success: 0, post: true });
          }
        );
  };
};

// like comments for postComments
export const commonLikeComment = (session, data, callback) => {
  const isDislike = data.delete;
  const isPatch = data.patch;
  const restURL = isDislike || isPatch ? `/${data.commentlikesid}` : '';
  let body = _.omit(data, ['delete', 'patch']);
  body = { resource: isPatch ? body : [body] };
  if (isPatch) {
    body = _.omit(data, ['delete', 'patch', 'commentlikesid']);
  }

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.commentlikes}${restURL}`;

  return dispatch => {
    isDislike
      ? deleteRequest(
          url,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        )
      : isPatch
      ? patchRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        )
      : postRequest(
          url,
          body,
          session,
          dispatch,
          res => {
            callback({ success: 1 });
          },
          error => {}
        );
  };
};

// --- Delete comments for postComments
export const commonDeleteComment = (
  session,
  idToDelete,
  tableToDeleteFrom,
  callback
) => {
  let delUrl = `${session.instance_url}${TABLE_URI_ADDON}/${tableToDeleteFrom}/${idToDelete}`;
  return dispatch => {
    deleteRequest(
      delUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const commonUploadFile = (session, filePath, fileName, callback) => {
  let filecontent = filePath.split(';base64,')[1];
  let mediaJson = {
    resource: [
      {
        name: fileName,
        type: 'file',
        is_base64: true,
        content: filecontent
      }
    ]
  };

  return dispatch => {
    uploadEncodedFile(
      `${getUploadBaseURL(session)}${FILES_URL}?check_exist=false`,
      session,
      mediaJson,
      dispatch,
      response => {
        callback({ success: 1, data: response });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const commonPinAction = (
  session,
  extra = {
    type: '', // social | community
    action: ALLOWED_PIN_ACTION_TYPES.pin, // pin | up | down | top | bottom | unpin
    id: null
  },
  callback = () => {}
) => {
  if (
    (_.isEmpty(extra?.type) &&
      !_.includes(
        [ALLOWED_FEATURE_KEYS.community, ALLOWED_FEATURE_KEYS.social],
        extra?.type
      )) ||
    _.isEmpty(extra?.action) ||
    _.isNull(extra?.id)
  )
    return dispatch => {
      showError(LocalStrings.dynamic.kSomethingWentWrongMsg);
      callback({ success: 0, data: null, error: null });
    };

  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.postCommon.togglePin.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.postCommon.togglePin.payload);
  postBody.eventid = session.eventid;
  postBody.type = extra.type;
  postBody.id = extra.id;

  switch (extra.action) {
    case 'up':
      postBody.pinned = 1;
      postBody.shift = -1;
      break;

    case 'down':
      postBody.pinned = 1;
      postBody.shift = 1;
      break;

    case 'top':
      postBody.pinned = 1;
      postBody.shift = 0;
      break;

    case ALLOWED_PIN_ACTION_TYPES.bottom:
      postBody.pinned = 1;
      postBody.shift = 2;
      break;

    case ALLOWED_PIN_ACTION_TYPES.unpin:
      postBody.pinned = 0;
      delete postBody.shift;
      break;

    case ALLOWED_PIN_ACTION_TYPES.pin:
    default:
      postBody.pinned = 1;
      delete postBody.shift;
      break;
  }

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res, error: null });
      },
      error => {
        showError(LocalStrings.dynamic.kSomethingWentWrongMsg);
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const commonReportContent = (session, payloadObj, callback) => {
  let postUrl = `${session?.instance_url}${TABLE_URI_ADDON}/${TABLES.reportedcontents}`;
  let postBody = {
    resource: [payloadObj]
  };

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        dispatch(
          fetchReportedContentsByUser(session, fetchRes => {
            callback({ success: 1 });
          })
        );
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const fetchReportedContentsByUser = (session, callback) => {
  let fetchFilter = encodeURI(
    `((eventid=${session.eventid})AND(reported_by=${session.userid}))`
  );
  let fetchUrl = `${session?.instance_url}${TABLE_URI_ADDON}/${TABLES.reportedcontents}?include_count=true&filter=${fetchFilter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        let reportContent = _.cloneDeep(ALLOWED_REPORTED_CONTENT_STRUCTURE);

        _.map(res?.resource, reportedItem => {
          switch (reportedItem?.type) {
            case ALLOWED_REPORTED_CONTENT_TYPES.community.post:
              reportContent.community.post.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.community.comment:
              reportContent.community.comment.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.gallery.post:
              reportContent.gallery.post.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.gallery.comment:
              reportContent.gallery.comment.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.social.post:
              reportContent.social.post.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.social.comment:
              reportContent.social.comment.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.liveqa.post:
              reportContent.liveqa.post.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.liveqa.comment:
              reportContent.liveqa.comment.push(reportedItem);
              break;

            case ALLOWED_REPORTED_CONTENT_TYPES.schedule.comment:
              reportContent.schedule.comment.push(reportedItem);
              break;

            default:
              break;
          }
        });

        let reportPayload = {
          data: reportContent,
          count: res.meta.count,
          list: res.resource
        };

        dispatch({ type: APPUSER_REPORTED_CONTENT, payload: reportPayload });
        callback({ success: 1, result: reportPayload, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};

export const fetchUserAccessByRole = (session, eventTabs, callback = null) => {
  let fetchUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.userInfo.endpoint}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        const accessDetails = res?.resource?.access ?? [];
        let appTabs = {};
        if (!_.isEmpty(eventTabs) && !_.isEmpty(accessDetails)) {
          _.map(accessDetails, (tab, tabId) => {
            const tabDetails = _.find(eventTabs, t => t?.apptabid == tabId);
            appTabs[tabId] = { ..._.cloneDeep(tabDetails), permissions: tab };
          });
        }

        dispatch({
          type: USER_ACCESS_BY_ROLE,
          payload: appTabs
        });
        callback && callback({ success: 1, data: res, error: null });
      },
      error => {
        callback && callback({ success: 0, data: null, error });
      }
    );
  };

  /**
    Schedules
      Polls & Live QA—>sessionpollandliveqa
    Speakers
    Exhibitors
    Sponsors
    Messages
    Maps
    News
    Social
      Moderate/Delete Other's Post—>moderate_social
    Event Guide
    Webview
    Gallery
      Moderate/Delete Other's Post—>moderate_gallery
      Add To Gallery—>add_gallery
    Survey
    Community
      Moderate/Delete Other's Post—>moderate_community
      Create Manage Meet-ups—>createmeetups_community
      Create Manage Job Post—>createjobpost_community
    Attendees
    Gamification
    Meeting—>meeting
      Can initiate meeting->can_initiate
    Scanning/Lead Generation—>scanning
      Scanning only->scanning_only
      Lead qualification—>lead_qualification
    Admin Features—>
      Manage Attendees—>manageattendees_adminfeature
      Session Checkins—>sessioncheckins_adminfeature
      Kiosk Mode—>kioskmode_adminfeature
   */
};

export const setShowCommonAccessDenied = value => {
  return dispatch =>
    dispatch({ type: COMMON_ACCESS_DENIED_RENDER, payload: value });
};

// Currently acting as reducer reset
export const updateUserAccessByRole = payload => {
  return dispatch => dispatch({ type: USER_ACCESS_BY_ROLE, payload });
};

/* ----------------- User details preparation section Starts ---------------- */
// ----- Manage the profile separations and section division creations
// ----- Will create property conditional_form {exhibitor: {}, personal: {}, speaker: {}, sponsor: {}}
const handleUserDetails = (userData, layouts) => {
  let processedUserDetails = {};
  let dynamicFormConditionalFields = [];
  let formJson = null;
  let lastSection = '';
  let lastFormSectionItem = {};

  // --- Conditional form property initialization
  processedUserDetails.conditional_form = {
    exhibitor: {},
    personal: {},
    speaker: {},
    sponsor: {}
  };

  // ===== Personal profile section starts =====
  processedUserDetails.personal_profile = [];
  formJson = JSON.parse(userData?.responses);
  lastSection = 'profile_details';
  lastFormSectionItem = {};

  // Static fields section, doesn't come in dynamic form
  processedUserDetails.personal_profile = {
    profile_details: {
      id: 'profile_details',
      label: 'Profile Details',
      section_items: []
    }
  };
  _.map(formJson, (formItem, formItemIndex) => {
    const isSection = formItem.key === 'section';
    let secName = _.split(_.trim(_.toLower(formItem.label)), ' ').join('_');
    let local_formItem = _.cloneDeep(formItem);

    // --- Conditional detecting
    if (!isSection && formItem?.hasCondition && !_.isEmpty(formItem?.options)) {
      let localConditional = processedUserDetails.conditional_form.personal;

      _.map(formItem.options, (optItem, optItemKey) => {
        if (!_.isEmpty(optItem?.displayfields)) {
          if (_.isEmpty(localConditional[formItem.name]))
            localConditional[formItem.name] = {};

          localConditional[formItem.name][optItem.value] = {
            section: lastSection,
            hide: _.split(optItem.displayfields, ',')
          };

          dynamicFormConditionalFields = [
            ...dynamicFormConditionalFields,
            ..._.split(optItem.displayfields, ',')
          ];
          dynamicFormConditionalFields = _.uniq(dynamicFormConditionalFields);
        }
      });
    }

    // - Conditional check (hide property added for individual form item)
    if (
      !_.isEmpty(lastFormSectionItem) &&
      lastFormSectionItem?.hideForCondition &&
      _.includes(dynamicFormConditionalFields, local_formItem.name)
    ) {
      local_formItem.hideForCondition = true;
    } else {
      local_formItem.hideForCondition = false;
      if (_.includes(dynamicFormConditionalFields, local_formItem.name))
        local_formItem.hideForCondition = true;
    }

    // --- Section form
    if (layouts?.attendee === ALLOWED_FORM_LAYOUTS.section) {
      if (isSection && !processedUserDetails.personal_profile[secName]) {
        processedUserDetails.personal_profile[secName] = local_formItem;
        processedUserDetails.personal_profile[secName].section_items = [];
        lastSection = secName;
      } else {
        processedUserDetails.personal_profile[lastSection].section_items.push(
          local_formItem
        );
      }
    } else if (layouts?.attendee === ALLOWED_FORM_LAYOUTS.single) {
      if (isSection)
        processedUserDetails.personal_profile.profile_details.section_items.push(
          { ..._.cloneDeep(local_formItem), section_items: [] }
        );
      else
        processedUserDetails.personal_profile.profile_details.section_items[
          processedUserDetails.personal_profile.profile_details.section_items
            .length - 1
        ].section_items.push(local_formItem);
    }

    if (isSection) lastFormSectionItem = local_formItem;
  });
  if (userData?.userattachments)
    processedUserDetails.personal_profile.private_docs = {
      id: 'private_docs',
      label: 'Private Docs',
      section_items: []
    };
  // =====  Personal profile section ends  =====

  // ===== Exhibitor profile section starts =====
  if (userData.exhibitoridfk && userData.exhibitors_by_exhibitoridfk) {
    processedUserDetails.exhibitor_profile = {
      profile_details: {
        id: 'profile_details',
        label: 'Profile Details',
        section_items: []
      }
    }; // Static fields section, doesn't come in dynamic form

    formJson = JSON.parse(userData.exhibitors_by_exhibitoridfk?.responses);
    lastSection = 'profile_details';
    dynamicFormConditionalFields = [];
    lastFormSectionItem = {};

    _.map(formJson, (formItem, formItemIndex) => {
      const isSection = formItem.key === 'section';
      let secName = _.split(_.trim(_.toLower(formItem.label)), ' ').join('_');
      let local_formItem = _.cloneDeep(formItem);

      // --- Conditional detecting
      if (
        !isSection &&
        formItem?.hasCondition &&
        !_.isEmpty(formItem?.options)
      ) {
        let localConditional = processedUserDetails.conditional_form.exhibitor;

        _.map(formItem.options, (optItem, optItemKey) => {
          if (!_.isEmpty(optItem?.displayfields)) {
            if (_.isEmpty(localConditional[formItem.name]))
              localConditional[formItem.name] = {};

            localConditional[formItem.name][optItem.value] = {
              section: lastSection,
              hide: _.split(optItem.displayfields, ',')
            };

            dynamicFormConditionalFields = [
              ...dynamicFormConditionalFields,
              ..._.split(optItem.displayfields, ',')
            ];
            dynamicFormConditionalFields = _.uniq(dynamicFormConditionalFields);
          }
        });
      }

      // - Conditional check (hide property added for individual form item)
      if (
        !_.isEmpty(lastFormSectionItem) &&
        lastFormSectionItem?.hideForCondition &&
        _.includes(dynamicFormConditionalFields, local_formItem.name)
      ) {
        local_formItem.hideForCondition = true;
      } else {
        local_formItem.hideForCondition = false;
        if (_.includes(dynamicFormConditionalFields, local_formItem.name))
          local_formItem.hideForCondition = true;
      }

      // --- Section form
      if (layouts?.exhibitor === ALLOWED_FORM_LAYOUTS.section) {
        if (isSection && !processedUserDetails.exhibitor_profile[secName]) {
          processedUserDetails.exhibitor_profile[secName] = local_formItem;
          processedUserDetails.exhibitor_profile[secName].section_items = [];
          lastSection = secName;
        } else {
          processedUserDetails.exhibitor_profile[
            lastSection
          ].section_items.push(local_formItem);
        }
      } else if (layouts?.exhibitor === ALLOWED_FORM_LAYOUTS.single) {
        if (isSection)
          processedUserDetails.exhibitor_profile.profile_details.section_items.push(
            { ..._.cloneDeep(local_formItem), section_items: [] }
          );
        else
          processedUserDetails.exhibitor_profile.profile_details.section_items[
            processedUserDetails.exhibitor_profile.profile_details.section_items
              .length - 1
          ].section_items.push(local_formItem);
      }

      if (isSection) lastFormSectionItem = local_formItem;
    });
  }
  // =====  Exhibitor profile section ends  =====

  // ====== Sponsor profile section starts ======
  if (userData.sponsoridfk && userData.sponsor_by_sponsoridfk) {
    processedUserDetails.sponsor_profile = {
      profile_details: {
        id: 'profile_details',
        label: 'Profile Details',
        section_items: []
      }
    }; // Static fields section, doesn't come in dynamic form

    formJson = JSON.parse(userData.sponsor_by_sponsoridfk?.responses);
    lastSection = 'profile_details';
    dynamicFormConditionalFields = [];
    lastFormSectionItem = {};

    _.map(formJson, (formItem, formItemIndex) => {
      const isSection = formItem.key === 'section';
      let secName = _.split(_.trim(_.toLower(formItem.label)), ' ').join('_');
      let local_formItem = _.cloneDeep(formItem);

      // --- Conditional detecting
      if (
        !isSection &&
        formItem?.hasCondition &&
        !_.isEmpty(formItem?.options)
      ) {
        let localConditional = processedUserDetails.conditional_form.sponsor;

        _.map(formItem.options, (optItem, optItemKey) => {
          if (!_.isEmpty(optItem?.displayfields)) {
            if (_.isEmpty(localConditional[formItem.name]))
              localConditional[formItem.name] = {};

            localConditional[formItem.name][optItem.value] = {
              section: lastSection,
              hide: _.split(optItem.displayfields, ',')
            };

            dynamicFormConditionalFields = [
              ...dynamicFormConditionalFields,
              ..._.split(optItem.displayfields, ',')
            ];
            dynamicFormConditionalFields = _.uniq(dynamicFormConditionalFields);
          }
        });
      }

      // - Conditional check (hide property added for individual form item)
      if (
        !_.isEmpty(lastFormSectionItem) &&
        lastFormSectionItem?.hideForCondition &&
        _.includes(dynamicFormConditionalFields, local_formItem.name)
      ) {
        local_formItem.hideForCondition = true;
      } else {
        local_formItem.hideForCondition = false;
        if (_.includes(dynamicFormConditionalFields, local_formItem.name))
          local_formItem.hideForCondition = true;
      }

      // --- Section form
      if (layouts?.sponsor === ALLOWED_FORM_LAYOUTS.section) {
        if (isSection && !processedUserDetails.sponsor_profile[secName]) {
          processedUserDetails.sponsor_profile[secName] = local_formItem;
          processedUserDetails.sponsor_profile[secName].section_items = [];
          lastSection = secName;
        } else {
          processedUserDetails.sponsor_profile[lastSection].section_items.push(
            local_formItem
          );
        }
      } else if (layouts?.sponsor === ALLOWED_FORM_LAYOUTS.single) {
        if (isSection)
          processedUserDetails.sponsor_profile.profile_details.section_items.push(
            { ..._.cloneDeep(local_formItem), section_items: [] }
          );
        else {
          processedUserDetails.sponsor_profile.profile_details.section_items[
            processedUserDetails.sponsor_profile.profile_details.section_items
              .length - 1
          ].section_items.push(local_formItem);
        }
      }

      if (isSection) lastFormSectionItem = local_formItem;
    });
  }
  // ======  Sponsor profile section ends  ======

  // ====== Speaker profile section starts ======
  if (userData.speakeridfk && userData.speaker_by_speakeridfk) {
    processedUserDetails.speaker_profile = {
      profile_details: {
        id: 'profile_details',
        label: 'Profile Details',
        section_items: []
      }
    }; // Static fields section, doesn't come in dynamic form
  }
  // ======  Speaker profile section ends  ======

  return { ...userData, ...processedUserDetails, layouts };
};

/**
 * @param sectionConditionalForm => Selected profile section's conditional form, fields that has conditional fields
 * {
 *    <op_value_field_name> : {
 *      <option_value>: {
 *        section: <op_value_field_name field's section name>,
 *        hide: ['<formitem_name_to_hide>', ... ]
 *      },
 *      ...
 *    },
 *     ...
 * }
 * @param sectionFormValues => Selected profile sections redux form values
 * @param profileToggleReducer => Whole profile toggle reducer with active tab, current profile section type, and all profile forms
 * @param autofill => Redux form's autofill props to be used to clear values of hidden fields
 *
 * NOTE: Adding hiding hide before render is essential to manage single field's render where its depending on multiple fields values
 */
export const handleHidingDynamicFormFields = (
  sectionConditionalForm,
  sectionFormValues,
  profileToggleReducer,
  lastModifiedFormField,
  formLayout,
  autofill = null
) => {
  // ----- Deep cloning current section and active tab object to modify locally to dispatch
  let selectedProfileSection = _.cloneDeep(
    profileToggleReducer?.data?.[profileToggleReducer?.type]
  );
  if (_.isEmpty(selectedProfileSection)) return dispatch => {};

  // let local_sectionFormValues = _.cloneDeep(sectionFormValues)
  let currentActiveTab = _.cloneDeep(profileToggleReducer?.active_tab);

  // ----- Common data variables
  let matchingCondition = null;
  let notMatchingConditions = null;

  // ----- Looping through the selected section's conditional form, a JSON which contains the conditional fields details
  _.map(sectionConditionalForm, (fieldValueWConditions, fieldName) => {
    // --- Finding the conditional form field from the sections redux-form to check the selected data
    let foundFormItem = _.find(
      sectionFormValues,
      (formItemValue, formItemName) => _.isEqual(formItemName, fieldName)
    );

    // --- Conditional form field with data found, so render required, else hide those fields accordingly
    if (!_.isEmpty(foundFormItem)) {
      // === DD || radio type fields will have values as String (e.g. '<ov1>')
      if (typeof foundFormItem === 'string') {
        // --- Hiding other values' fields
        notMatchingConditions = _.find(
          fieldValueWConditions,
          (conditionDetails, possibleValue) =>
            !_.isEqual(possibleValue, foundFormItem)
        );
        if (!_.isEmpty(notMatchingConditions)) {
          // Looping each selected value corresponding fields to hide
          handleCorrespondingHideShow(
            notMatchingConditions?.hide,
            selectedProfileSection,
            currentActiveTab,
            autofill,
            true,
            lastModifiedFormField,
            sectionFormValues,
            formLayout
          );
        }

        // --- Selecting the possible condition value details based on selected value
        matchingCondition = _.find(
          fieldValueWConditions,
          (conditionDetails, possibleValue) =>
            _.isEqual(possibleValue, foundFormItem)
        );
        if (!_.isEmpty(matchingCondition)) {
          handleCorrespondingHideShow(
            matchingCondition?.hide,
            selectedProfileSection,
            currentActiveTab,
            autofill,
            false,
            lastModifiedFormField,
            sectionFormValues,
            formLayout
          );
        }
      }
      // === checkbox type field will have values as Array of string (e.g. ['<ov1>','<ov2>', ...])
      else if (typeof foundFormItem === 'object') {
        // --- Hiding other values' fields
        notMatchingConditions = _.filter(
          fieldValueWConditions,
          (conditionDetails, possibleValue) =>
            !_.includes(foundFormItem, possibleValue)
        );

        if (!_.isEmpty(notMatchingConditions)) {
          _.map(notMatchingConditions, notMatchedCondition => {
            handleCorrespondingHideShow(
              notMatchedCondition?.hide,
              selectedProfileSection,
              currentActiveTab,
              autofill,
              true,
              lastModifiedFormField,
              sectionFormValues,
              formLayout
            );
          });
        }

        // --- Looping checkbox array values as it's multiselect
        _.map(foundFormItem, fFIitem => {
          matchingCondition = _.filter(
            fieldValueWConditions,
            (conditionDetails, possibleValue) =>
              _.isEqual(possibleValue, fFIitem)
          );

          if (!_.isEmpty(matchingCondition)) {
            _.map(matchingCondition, matchedCondition => {
              handleCorrespondingHideShow(
                matchedCondition?.hide,
                selectedProfileSection,
                currentActiveTab,
                autofill,
                false,
                lastModifiedFormField,
                sectionFormValues,
                formLayout
              );
            });
          }
        });
      }
    }
    // Next else will work if selected data becomes blank, meaning user deleted value for the field
    else {
      _.map(fieldValueWConditions, (valueDetails, value) => {
        handleCorrespondingHideShow(
          valueDetails?.hide,
          selectedProfileSection,
          currentActiveTab,
          autofill,
          true,
          lastModifiedFormField,
          sectionFormValues,
          formLayout
        );
      });
    }
  });

  let payloadObj = {
    ...profileToggleReducer,
    data: {
      ...profileToggleReducer.data,
      [profileToggleReducer?.type]: selectedProfileSection
    },
    active_tab: currentActiveTab
  };

  return dispatch => dispatch(setProfilePortalToggle(payloadObj));
};

const handleCorrespondingHideShow = (
  hideShowItems,
  selectedprofileSection,
  currentActiveTab,
  autofill,
  hideMode,
  lastModifiedFormField,
  sectionFormValues,
  formLayout
) => {
  const isSingle = formLayout === ALLOWED_FORM_LAYOUTS.single;

  let local_selectedprofileSection = isSingle
    ? selectedprofileSection?.profile_details?.section_items
    : selectedprofileSection;

  _.map(hideShowItems, item => {
    // - Managing full form (within current section + next section)
    _.map(local_selectedprofileSection, (sectionDetails, sectionName) => {
      if (_.isEqual(item, sectionDetails.name)) {
        sectionDetails.hideForCondition = hideMode;

        _.map(sectionDetails.section_items, (secItem, secItemIndex) => {
          secItem.hideForCondition = hideMode;

          if (hideMode) {
            !_.isEqual(lastModifiedFormField, secItem?.name) &&
              clearFormFieldValue(secItem, autofill);
          } else if (!_.isEmpty(sectionFormValues[secItem?.name]))
            setFormFieldValue(
              secItem?.name,
              sectionFormValues[secItem?.name],
              autofill
            );
        });
      } else {
        let lastFormSectionItem = {};
        _.map(sectionDetails.section_items, (secItem, secItemIndex) => {
          if (_.isEqual(item, secItem?.name)) {
            secItem.hideForCondition = hideMode;

            if (hideMode) {
              !_.isEqual(lastModifiedFormField, secItem?.name) &&
                clearFormFieldValue(secItem, autofill);
            } else if (!_.isEmpty(sectionFormValues[secItem?.name]))
              setFormFieldValue(
                secItem?.name,
                sectionFormValues[secItem?.name],
                autofill
              );

            if (_.isEqual(secItem?.key, 'section'))
              lastFormSectionItem = secItem;
          }

          if (
            !_.isEmpty(lastFormSectionItem) &&
            !_.isNil(lastFormSectionItem?.hideForCondition)
          ) {
            secItem.hideForCondition = lastFormSectionItem.hideForCondition;

            if (hideMode) {
              !_.isEqual(lastModifiedFormField, secItem?.name) &&
                clearFormFieldValue(secItem, autofill);
            } else if (!_.isEmpty(sectionFormValues[secItem?.name]))
              setFormFieldValue(
                secItem?.name,
                sectionFormValues[secItem?.name],
                autofill
              );
          }
        });
      }
    });

    // - Managing current active tab
    let lastFormSectionItem = {};
    _.map(currentActiveTab.section_items, (secItem, secItemIndex) => {
      if (!isSingle) {
        if (_.isEqual(item, secItem?.name)) {
          secItem.hideForCondition = hideMode;

          if (hideMode) {
            !_.isEqual(lastModifiedFormField, secItem?.name) &&
              clearFormFieldValue(secItem, autofill);
          } else if (!_.isEmpty(sectionFormValues[secItem?.name]))
            setFormFieldValue(
              secItem?.name,
              sectionFormValues[secItem?.name],
              autofill
            );

          if (_.isEqual(secItem?.key, 'section')) lastFormSectionItem = secItem;
        }

        if (
          !_.isEmpty(lastFormSectionItem) &&
          !_.isNil(lastFormSectionItem?.hideForCondition)
        ) {
          secItem.hideForCondition = lastFormSectionItem.hideForCondition;

          if (hideMode) {
            !_.isEqual(lastModifiedFormField, secItem?.name) &&
              clearFormFieldValue(secItem, autofill);
          } else if (!_.isEmpty(sectionFormValues[secItem?.name]))
            setFormFieldValue(
              secItem?.name,
              sectionFormValues[secItem?.name],
              autofill
            );
        }
      } else {
        if (_.isEqual(item, secItem.name)) {
          secItem.hideForCondition = hideMode;
          if (_.isEqual(secItem?.key, 'section')) lastFormSectionItem = secItem;

          _.map(secItem.section_items, subSecItem => {
            subSecItem.hideForCondition = hideMode;

            if (hideMode) {
              clearFormFieldValue(secItem, autofill);
            } else if (!_.isEmpty(sectionFormValues[secItem?.name]))
              setFormFieldValue(
                secItem?.name,
                sectionFormValues[secItem?.name],
                autofill
              );
          });
        } else {
          _.map(secItem.section_items, subSecItem => {
            if (_.isEqual(secItem?.key, 'section'))
              lastFormSectionItem = subSecItem;

            if (_.isEqual(item, subSecItem?.name)) {
              subSecItem.hideForCondition = hideMode;

              if (hideMode) {
                !_.isEqual(lastModifiedFormField, subSecItem?.name) &&
                  subSecItem.hideForCondition &&
                  clearFormFieldValue(subSecItem, autofill);
              } else if (!_.isEmpty(sectionFormValues[subSecItem?.name]))
                setFormFieldValue(
                  subSecItem?.name,
                  sectionFormValues[subSecItem?.name],
                  autofill
                );

              if (_.isEqual(subSecItem?.key, 'section'))
                lastFormSectionItem = subSecItem;
            }

            if (
              !_.isEmpty(lastFormSectionItem) &&
              !_.isNil(lastFormSectionItem?.hideForCondition)
            ) {
              subSecItem.hideForCondition =
                lastFormSectionItem.hideForCondition;

              if (hideMode) {
                !_.isEqual(lastModifiedFormField, subSecItem?.name) &&
                  subSecItem.hideForCondition &&
                  clearFormFieldValue(subSecItem, autofill);
              } else if (!_.isEmpty(sectionFormValues[subSecItem?.name]))
                setFormFieldValue(
                  subSecItem?.name,
                  sectionFormValues[subSecItem?.name],
                  autofill
                );
            }
          });
        }
      }
    });
  });
};

const clearFormFieldValue = (field, autofill) => {
  autofill(field?.name, null);
};

const setFormFieldValue = (name, value, autofill) => {
  autofill(name, value);
};
/* ------------------ User details preparation section Ends ----------------- */

export const setLastModifiedFormField = value => {
  return dispatch =>
    dispatch({ type: LAST_MODIFIED_REDUXFORM_FIELD, payload: value });
};

export const getNetworkingUsersCount = (session, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventifyScriptSupport.appuserCount.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.eventifyScriptSupport.appuserCount.payload);
  body.eventid = session.eventid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const setRestrictAtEditProfile = val => {
  return dispatch => dispatch({ type: RESTRICT_USER_IN_EDIT, payload: val });
};

export const requestAccountDelete = (session, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.postCommon.deleteAcc.endpoint}`;

  return dispatch => {
    postRequest(
      postUrl,
      SCRIPTS.postCommon.deleteAcc.payload,
      session,
      dispatch,
      res => {
        callback({ success: 1, error: null });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const fetchDynamicFilteredList = (session, value, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.dynamicFilter.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.getCommon.dynamicFilter.payload);
  postBody.type = value;
  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      result => {
        callback({ success: 1, data: result.resource });
      },
      error => {
        callback({ success: 0, data: [] });
      }
    );
  };
};

export const fetchDynamicFilteredUserList = (
  session,
  value,
  type,
  callback
) => {
  let getUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.dynamicFilterUsers.endpoint}?type=${type}&searchText=${value}`;
  return dispatch => {
    getRequest(
      getUrl,
      session,
      dispatch,
      result => {
        callback({ success: 1, data: result.resource });
      },
      error => {
        callback({ success: 0, data: [] });
      }
    );
  };
};

export const updateAppLanguage = value => {
  return dispatch => dispatch({ type: CHANGE_APP_LANGUAGE, payload: value });
};

export const updateAppTheme = (
  eventDetails = {},
  eventSettings = {},
  theme = ALLOWED_APP_THEMES.light,
  userChoseTheme = false,
  initial = false
) => {
  if (_.isEmpty(eventDetails) || !_.includes(ALLOWED_APP_THEMES.types, theme))
    return dispatch => {};

  const root = document.documentElement;
  const darkThemeColor = eventDetails?.darkthemecolor;
  const lightThemeColor = eventDetails?.themecolor;
  let themeToSet = _.cloneDeep(theme);

  const overviewSettings = eventSettings?.overview_settings;
  const adminSetPreferredTheme = !_.isEmpty(overviewSettings?.appearance)
    ? overviewSettings?.appearance
    : ALLOWED_APP_THEMES.auto;
  const adminSetPreferredThemeIsAuto = _.isEqual(
    ALLOWED_APP_THEMES.auto,
    adminSetPreferredTheme
  );

  if (
    initial &&
    (!adminSetPreferredThemeIsAuto ||
      (!userChoseTheme && adminSetPreferredThemeIsAuto))
  ) {
    theme = adminSetPreferredTheme;
    themeToSet = adminSetPreferredTheme;
  }

  switch (theme) {
    case ALLOWED_APP_THEMES.dark:
      handleDarkThemeSet();
      break;

    case ALLOWED_APP_THEMES.light:
      handleLightThemeSet();
      break;

    case ALLOWED_APP_THEMES.auto:
    default:
      handleAutoThemeSet();
      break;
  }

  function handleDarkThemeSet() {
    document.body.classList.add('dark');
    root.style.setProperty('--theme-color', darkThemeColor);
  }

  function handleLightThemeSet() {
    document.body.classList.remove('dark');
    root.style.setProperty('--theme-color', lightThemeColor);
  }

  function handleAutoThemeSet() {
    const userPrefersDarkTheme = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;

    document.body.className = '';
    if (userPrefersDarkTheme) {
      handleDarkThemeSet();
      themeToSet = ALLOWED_APP_THEMES.dark;
    } else {
      root.style.setProperty('--theme-color', lightThemeColor);
      themeToSet = ALLOWED_APP_THEMES.light;
    }
  }

  return dispatch =>
    dispatch({
      type: CHANGE_APP_THEME,
      payload: { applied: themeToSet, chosen: theme }
    });
};

export const fetchUserAddonData = (
  session,
  userDetails = {},
  callback = null
) => {
  if (_.isEmpty(userDetails)) return dispatch => {};

  let filter = encodeURI(
    `((eventid=${session?.eventid})AND(appuserid=${session?.userid}))`
  );
  let fetchUrl = `${session?.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}?minimize=true&fields=${FIELDS.appuser.mediumInfo}&filter=${filter}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        let payloadObj = { ...userDetails, ...res?.resource?.[0] };
        dispatch({ type: USER_DETAILS_ADDON, payload: res?.resource?.[0] });
        callback &&
          callback({
            success: 1,
            data: payloadObj,
            message: null
          });
      },
      error => {
        callback && callback({ success: 0, data: null, message: error });
      }
    );
  };
};

export const setAppFeaturesList = featureList => {
  return dispatch => dispatch({ type: APP_FEATURE_LIST, payload: featureList });
};

export const fetchRecommendedByType = (
  session,
  extra = { type: '' },
  callback
) => {
  if (_.isEmpty(extra?.type))
    return dispatch => {
      callback({
        success: 0
      });
    };

  let fetchUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.recommended.endpoint}?type=${extra?.type}`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
